import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const [menuItems, setMenuItems] = useState([
    {
      id: "widgets",
      label: "Dashboard",
      icon: "ri-honour-line",
      link: "/dashboard",
      pkey: "Dashboard",
      parentId: "dashboard",
    },
    {
      id: "users",
      pkey: "Users",
      label: "Users",
      link: "/users",
      icon: "ri-user-line",
      parentId: "users",
    },
    {
      id: "subscriptions",
      pkey: "Subscriptions",
      label: "Subscriptions",
      link: "/subscriptions",
      icon: "ri-money-dollar-box-line",
      parentId: "subscriptions",
    },
    {
      id: "news",
      pkey: "News",
      label: "News",
      link: "/news",
      icon: "ri-newspaper-line",
      parentId: "news",
    },
    {
      id: "posts",
      pkey: "Posts",
      label: "Posts",
      link: "/posts",
      icon: "ri-file-list-3-line",
      parentId: "posts",
    },
    {
      id: "drawings-history",
      pkey: "DrawingsHistory",
      label: "Drawings History",
      link: "/drawings-history",
      icon: "ri-history-line",
      parentId: "drawings-history",
    },
    {
      id: "chats",
      pkey: "Chats",
      label: "Group Chats",
      link: "/chats",
      icon: "ri-chat-1-line",
      parentId: "chats",
    },
    {
      id: "privacy",
      pkey: "PrivacyPolicy",
      label: "Privacy Policy",
      link: "/privacy-policy",
      icon: "ri-shield-user-line",
      parentId: "privacy",
    },
    {
      id: "terms",
      pkey: "TermsConditions",
      label: "Terms & Conditions",
      link: "/terms-and-conditions",
      icon: "ri-file-text-line",
      parentId: "terms",
    },
    {
      id: "contectus",
      pkey: "ContectUs",
      label: "Contact Us",
      link: "/contact-us",
      icon: "ri-file-text-line",
      parentId: "terms",
    },
  ]);

  const dynamicmenuItems = menuItems;

  return <React.Fragment>{dynamicmenuItems}</React.Fragment>;
};

export default Navdata;
